function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var ts = /*#__PURE__*/function () {
  function ts(t) {
    _classCallCheck(this, ts);

    this.xc = t, this.xc = t;
  }

  _createClass(ts, [{
    key: "zc",
    value: function zc(t) {
      return null == this.xc || this.xc === t[0];
    }
  }, {
    key: "bt",
    value: function bt() {
      return this.xc;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new ts(t ? t.event_name : null);
    }
  }]);

  return ts;
}();

export { ts as default };